import React from 'react'

export const DeletedSkillContext = React.createContext({
  lastDeletedSkillId: null as string | null,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setLastDeletedSkillId: (id: string) => {},
})

export const RemoveSkillContext = React.createContext({
  lastRemovedSkillId: null as string | null,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setLastRemovedSkillId: (id: string) => {},
})

export const BulkDeletedSkillContext = React.createContext<{
  checkedSkillIds: string[]
  addCheckedSkillId: (id: string) => void
  removeCheckedSkillId: (id: string) => void
  removeSkillFromData?: (id: string) => void
}>({
  checkedSkillIds: [],
  addCheckedSkillId: () => {},
  removeCheckedSkillId: () => {},
  removeSkillFromData: undefined,
})
